export default __webpack_public_path__ + "static/media/auth.93045a00.svg";